import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

/**
 * Saves the user's support contact phone number and sends it a verification OTP.
 * Distinct from the identity phone (which is derived from NIN); the two may hold
 * the same value.
 */
function useSendContactPhoneOtp(
  options?: MutationOptions<APIResponse<any>, APIError, Record<any, any>>
) {
  const {
    isLoading: sendingContactOTP,
    isError: isSendError,
    error: sendError,
    mutate: sendContactOTP,
  } = useMutation(async (variables?: Record<any, any>) => {
    return await post(
      API_URL +
        "/onboarding/users/onboarding/verifications/send-contact-phone-otp",
      variables,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
  }, options);

  return {
    sendContactOTP,
    sendingContactOTP,
    isSendError,
    sendError,
  };
}

export default useSendContactPhoneOtp;
